import React, { useEffect } from 'react'
import Header from '../Header/Header'
import Nav from '../Header/Nav'
import CategoryPage from './CategoryPage'
import Footer from '../Footer/Footer'
import WhatssapIcon from '../Home/WhatssapIcon'

const Categorie = () => {

  useEffect(() => {
    // This is more reliable for sticky headers
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
}, []);


  return (
    <div>

        <Header />

        <Nav target="categorie" />

        <CategoryPage />

        <WhatssapIcon/>

        <Footer />



    </div>
  )
}

export default Categorie